import styled from "styled-components";

export const ViewPageContainer = styled.div`
  position: relative;
  padding: 12px 40px 50px 40px;
  color: rgb(32, 22, 44);
  font-size: 14px;
  background: #f9fafc;
  border-radius: 6px;
  //font-family: 'FuturaPT', sans-serif;

  @media (max-width: 768px) {
    padding: 12px 10px 50px;
    font-size: 14px;
  }
`

export const ViewHeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

export const CompanyHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`
export const CompanyLogoContainer = styled.div`
  width: 300px;
  height: 300px;
  margin-right: 32px;
  background: #ffffff;

  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: -webkit-center;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, .2);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
  /* float: left; */
  margin-bottom: 20px;
  transition: all ease .2s;

  @media (max-width: 768px) {
    margin-right: 0;
    align-items: center;
  }
`
export const CompanyLogo = styled.img`
  width: 100%;
  height: 100%;
  

  object-fit: contain;

  @media (max-width: 768px) {
    width: 240px;
    height: 240px;
    margin-right: 0;
  }
`

export const CompanyTitle = styled.span`
  max-width: 600px;
  font-size: 2.5em;
  font-weight: 600;
  text-transform: uppercase;

  @media (max-width: 768px) {
    max-width: none;
    font-size: 1.9rem;
  }
`

export const CompanyStand = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 3px 12px;
  margin-right: 30px;
  width: 320px;

  font-size: 1.2em;
  font-weight: 600;

  color: #fff;
  background: #6AA6C7;
  border-radius: 5px;

  @media (max-width: 768px) {
    width: 46%;
    position: relative;
    margin-right: 8px;
    font-size: 0.9em;
    padding-top: 5px;

    margin-bottom: 1rem;

    
  } 
`
export const CompanyStandPavilion = styled.div`
  @media (max-width: 768px) {
    display: flex;


  }
`
export const CompanyPavilion = styled.div`
  position: absolute;
  top: 36px;
  right: 0px;
  padding: 3px 12px;
  margin-right: 30px;
  width: 320px;

  font-size: 1.2em;
  font-weight: 600;

  color: #fff;
  background: #6AA6C7;
  border-radius: 5px;

  @media (max-width: 768px) {
    width: 46%;
    position: relative;
    top: 0px;
    font-size: 0.9em;
    margin-right: 0px;
    padding-top: 5px;

    margin-bottom: 1rem;

    
  } 
`

export const ViewBodyContainer = styled.div`
  display: flex;
  gap: 80px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 24px;
  }
`

export const CompanyDescription = styled.div`
  font-size: 1.5em;
  line-height: 1;
  flex-grow: 1;
  text-transform: none;
`
